import classNames from "classnames";
import React from "react";
import SponsorAdBranding from "../../../../shared/components/sponsorAdBranding";
import { AdOrientation } from "../../../../shared/components/sponsorAdBranding/type";
import { useRegDetail } from "../../../../shared/context/regDetail";
import InventorySubType from "../../../../shared/enums/InventorySubType";

export default function FormTitle(props: FormTitleType) {
  const { emailSponsorBannerLocationUrl } = useRegDetail();

  const sponsorAdList = React.useMemo(() => {
    if (!emailSponsorBannerLocationUrl) {
      return;
    }
    return [{ sponsorImgUrl: emailSponsorBannerLocationUrl }];
  }, [emailSponsorBannerLocationUrl]);

  return (
    <section className={classNames("regFormTitle_wrapper", props.className)}>
      <div className={classNames("regFormTitle", { hasSponsorAdList: sponsorAdList })}>
        <div className="container">
          <h1>{props.title}</h1>
        </div>
        {sponsorAdList && (
          <SponsorAdBranding
            uuid={"regHeader"}
            displayHeader={false}
            adList={sponsorAdList}
            className={"regFormSponsor"}
            orientation={AdOrientation.HORIZONTAL}
            inventorySubType={InventorySubType.REGISTRATION}
          />
        )}
      </div>
    </section>
  );
}
